import { Maybe } from '@codegrade/maybe';
import { sort } from '@codegrade/utils';
import { getStoreBuilder } from '@codegrade/vuex-typex';
import client from '@/client';
import * as utils from '@/utils';
import { UserStore } from './user';
const storeBuilder = getStoreBuilder();
const moduleBuilder = storeBuilder.module('peer_feedback', {
    connections: {},
    loaders: {
        peerFeedbackConnections: {},
    },
});
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var PeerFeedbackStore;
(function (PeerFeedbackStore) {
    const commitClearAllConnections = moduleBuilder.commit((state, _) => {
        state.connections = {};
        state.loaders.peerFeedbackConnections = {};
    }, 'commitClearAllConnections');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.commitClearConnections = moduleBuilder.commit(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (state, { assignmentId }) => {
        utils.vueDelete(state.connections, assignmentId);
        utils.vueDelete(state.loaders.peerFeedbackConnections, assignmentId);
    }, 'commitClearConnections');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.commitSetConnectionsForUser = moduleBuilder.commit((state, payload) => {
        if (state.connections[payload.assignmentId] == null) {
            utils.vueSet(state.connections, payload.assignmentId, {});
        }
        utils.vueSet(state.connections[payload.assignmentId], payload.peerId, payload.subjects);
    }, 'commitSetConnectsionsForUser');
    // eslint-disable-next-line
    function _getConnectionsForUser(state) {
        const loggedIn = UserStore.loggedInUser();
        return (assignment, userId) => Maybe.fromNullable(state.connections[assignment.id]?.[userId]).map(users => sort.sortBy(users, user => [
            utils.user
                .displayName({
                user,
                assignment: Maybe.of(assignment),
                group: Maybe.empty(),
                loggedIn,
            })
                .orDefault('Unknown'),
        ]));
    }
    const commitLoader = moduleBuilder.commit((state, 
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    payload) => {
        const { assignmentId, userId, maybeLoader } = payload;
        let byAssig = state.loaders.peerFeedbackConnections[assignmentId];
        if (byAssig == null) {
            byAssig = {};
            state.loaders.peerFeedbackConnections[assignmentId] = byAssig;
        }
        maybeLoader.caseOf({
            Just: loader => utils.vueSet(byAssig, userId, loader),
            Nothing: () => utils.vueDelete(byAssig, userId),
        });
    }, 'commitLoader');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.getConnectionsForUser = moduleBuilder.read(_getConnectionsForUser, 'getConnectionsForUser');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PeerFeedbackStore.loadConnectionsForUser = moduleBuilder.dispatch((context, payload) => {
        const { assignment, userId, force = false } = payload;
        const state = context.state;
        if (!force && state.connections[assignment.id]?.[userId] != null) {
            return null;
        }
        let loader = state.loaders.peerFeedbackConnections?.[assignment.id]?.[userId];
        if (force || loader == null) {
            loader = (async () => {
                const data = await Array.fromAsync(utils.loadAllPages(nextToken => client.p.assignment.getPeerFeedbackSubjects({
                    assignmentId: assignment.id,
                    userId,
                    nextToken: nextToken.extract(),
                })));
                commitLoader({
                    assignmentId: assignment.id,
                    userId,
                    maybeLoader: Maybe.empty(),
                });
                const users = data.map(d => d.subject);
                PeerFeedbackStore.commitSetConnectionsForUser({
                    assignmentId: assignment.id,
                    peerId: userId,
                    subjects: users,
                });
            })();
            commitLoader({
                assignmentId: assignment.id,
                userId,
                maybeLoader: Maybe.of(loader),
            });
        }
        return loader;
    }, 'loadConnectionsForUser');
    utils.signal.AFTER_USER_CHANGED.registerSync(() => {
        commitClearAllConnections();
    });
})(PeerFeedbackStore || (PeerFeedbackStore = {}));
